const namespace = 'virtual-terminal-v2';
export default namespace;
